'use client';

import React, { type FC } from 'react';
import type { GiftQuantityBadgeProps } from './gift-quantity-badge.types';
import styles from './gift-quantity-badge.module.css';
import { cn, Text } from '../../../../../utils';

export const GiftQuantityBadge: FC<GiftQuantityBadgeProps> = ({ quantity, className }) => {
    return (
        <Text size="small" weight="medium" className={cn(styles.badge, className)}>
            x {quantity}
        </Text>
    );
};
